import script from "./Screen.vue?vue&type=script&setup=true&lang=js"
export * from "./Screen.vue?vue&type=script&setup=true&lang=js"

import "./Screen.vue?vue&type=style&index=0&id=14a9e852&scoped=true&lang=css"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14a9e852"]])

export default __exports__